export class ExtendedError extends Error {

    constructor(
        message: string,
        readonly info: {[k: string]: any},
    ) {
        super(message);
    }
}
